/**
 * Lazy-loaded icons with encapsulated Suspense boundaries.
 */
import React, { Suspense } from 'react';

// oxlint-disable-next-line @atlassian/no-restricted-imports
import { lazyForPaint } from '@atlassian/react-loosely-lazy';

const LazyForgeGdriveEugeneTestProdIconComponent = lazyForPaint(
	() =>
		import(/* webpackChunkName: "icon-forge-gdrive-eugene-test-prod" */ './utils').then(
			(m) => m.ForgeGdriveEugeneTestProdIcon,
		),
	{ moduleId: '@atlassian/rovo-connectors-config/forge-gdrive-eugene-test-prod/icon' },
);

const LazyForgeGdriveEugeneTestProdSearchResultIconComponent = lazyForPaint(
	() =>
		import(
			/* webpackChunkName: "icon-forge-gdrive-eugene-test-prod-search-result" */ './utils'
		).then((m) => m.ForgeGdriveEugeneTestProdSearchResultIcon),
	{
		moduleId: '@atlassian/rovo-connectors-config/forge-gdrive-eugene-test-prod/search-result-icon',
	},
);

/**
 * Exported icons with self-contained Suspense boundaries.
 * Consumers can use these directly without wrapping in LazySuspense.
 */
export const ForgeGdriveEugeneTestProdIcon = (): React.JSX.Element => (
	<Suspense fallback={null}>
		<LazyForgeGdriveEugeneTestProdIconComponent />
	</Suspense>
);

export const ForgeGdriveEugeneTestProdSearchResultIcon = (): React.JSX.Element => (
	<Suspense fallback={null}>
		<LazyForgeGdriveEugeneTestProdSearchResultIconComponent />
	</Suspense>
);
